import { render, staticRenderFns } from "./KeuringenVerwerkt.vue?vue&type=template&id=1a5aaf62"
import script from "./KeuringenVerwerkt.vue?vue&type=script&lang=js"
export * from "./KeuringenVerwerkt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports